import React, { useState } from "react";
import { PlayIcon } from "./icons";

export default function NormanSection() {
  const [playing, setPlaying] = useState(false);
  const portrait = "https://customer-assets.emergentagent.com/job_fork-hub-1/artifacts/js5xog3b_show-photo.jpg";

  return (
    <section data-testid="norman-section" className="relative py-24 md:py-32 bk-glow">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="bk-card rounded-3xl overflow-hidden p-8 md:p-12">
          <div className="grid lg:grid-cols-2 gap-10 items-start">
            {/* Bio */}
            <div>
              <span className="text-[11px] uppercase tracking-[0.28em] text-gold/80">
                Featured Endorsement
              </span>
              <h2 className="mt-4 font-display text-4xl md:text-5xl">
                Norman <span className="bk-gold-text italic">Seeff</span>
              </h2>
              <p className="mt-3 text-gold/90 text-sm uppercase tracking-[0.2em]">
                Iconic Photographer &amp; Filmmaker · The Creative Process
              </p>
              <p className="mt-6 text-white/70 leading-relaxed">
                Norman Seeff is a photographer and filmmaker whose work is centered on the
                exploration of human creativity and the inner dynamics of the creative process.
                Over his career, he has photographed and filmed some of the most influential
                cultural figures of the last century, including Steve Jobs, Tina Turner,
                Joni Mitchell, Patti Smith, Andy Warhol, Miles Davis, Ray Charles, The Rolling
                Stones, The Jacksons, Cher, Steve Martin, and Martin Scorsese. His sessions are
                known for going beyond traditional portraiture, creating space for artists,
                musicians, actors, innovators, and visionaries to reveal the emotion, energy,
                and creative force behind their work.
              </p>
              <p className="mt-4 text-sm text-white/55">
                <span className="text-gold/80 font-semibold">Known for:</span> Steve Jobs · Tina Turner · Joni Mitchell · Patti Smith · Andy Warhol · The Rolling Stones
              </p>
            </div>

            {/* Video */}
            <div>
              <div className="relative rounded-2xl overflow-hidden border border-gold/30 aspect-video">
                {playing ? (
                  <iframe
                    className="absolute inset-0 w-full h-full"
                    src="https://www.youtube.com/embed/EIGNjvQ0STQ?autoplay=1&rel=0"
                    title="Testimonial from Norman Seeff"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                ) : (
                  <button
                    onClick={() => setPlaying(true)}
                    data-testid="norman-play"
                    className="absolute inset-0 w-full h-full group"
                    aria-label="Play Norman Seeff testimonial"
                  >
                    <img src={portrait} alt="Norman Seeff" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent" />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <span className="w-20 h-20 rounded-full bk-shimmer flex items-center justify-center text-black shadow-2xl group-hover:scale-110 transition-transform">
                        <PlayIcon className="w-9 h-9 ml-0.5" />
                      </span>
                    </div>
                    <div className="absolute bottom-5 left-5 right-5 text-left">
                      <div className="text-[10px] uppercase tracking-[0.28em] text-gold/90">Testimonial</div>
                      <div className="font-display text-xl md:text-2xl mt-1 text-white">
                        Testimonial from Norman Seeff
                      </div>
                    </div>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
